import { IReduxState } from 'app/store';
import { AppLoading } from 'common/components/appLoading/appLoading';
import { PopupHeader } from 'common/components/PopupHeader/PopupHeader';
import { RestApi } from 'common/services/rest-api.service';
import { getRows } from 'features/GridSlice';
import { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSuccess, showError } from 'features/AlertSlice';
import classNames from 'classnames';
import './RemovedAssetsDeleteConfirmPopup.scss';

interface RemovedAssetsDeleteConfirmPopupProps {
  onClose: () => void;
  selectedIds: any[];
  message?: string;
}

export function RemovedAssetsDeleteConfirmPopup(props: RemovedAssetsDeleteConfirmPopupProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch<any>();
  const { rows } = useSelector((state: IReduxState) => state.grid);

  const selectedRows = useMemo(() => {
    return rows.filter((row: any) => props.selectedIds.includes(row.asset_name));
  }, [rows, props.selectedIds]);

  const assets = useMemo(() => {
    return selectedRows.map((row: any) => ({
      name: row.asset_name,
      type: row.type
    }));
  }, [selectedRows]);

  const onApprove = () => {
    setLoading(true);

    RestApi.setData(
      'settings/asset-management/removed-assets/bulk-delete/',
      { assets },
      'POST'
    ).subscribe(
      (response: any) => {
        dispatch(showSuccess('Assets restored successfully'));
        dispatch(getRows());
        setLoading(false);
        props.onClose();
      },
      error => {
        dispatch(showError('Failed to restore asset'));
        setLoading(false);
        props.onClose();
      }
    );
  };

  return (
    <div className="RemovedAssetsDeleteConfirmPopup popup-inner-wrapper">
      <PopupHeader text="Confirm Restoration" onClose={props.onClose} />
      <div className="popup-inner">
        <div className="message">
          <div>{props.message || 'Are you sure you would like to restore the selected assets?'}</div>
        </div>

        <div className="assets-list">
          <label>Assets to be restored:</label>
          <ul>
            {selectedRows.map((row: any) => (
              <li key={row.asset_name}>{row.asset_name}</li>
            ))}
          </ul>
        </div>

        <div className="buttons-wrapper">
          <button className="btn btn-big btn-secondary" onClick={props.onClose}>
            Cancel
          </button>
          <button
            className={classNames('btn', 'btn-big', 'btn-main')}
            onClick={onApprove}
            disabled={loading}
          >
            Yes, Restore
          </button>
        </div>
      </div>
      {loading && <AppLoading />}
    </div>
  );
}
